import React from "react";

const Chapter1 = () => {
  return (
    <>
      <h2>What are metals and trace elements?</h2>
      <p>
        Trace elements, such as metals, occur naturally in small amounts in the
        environment. These include elements such as lead, iron, arsenic, radium,
        and radon. Certain metals are essential nutrients, but these elements
        can become toxic at high levels.
      </p>
      <p>
        Metals originate from the earth, but after mining, processing, and
        manufacturing many of these elements can be found in your home. The
        properties of these elements can make them great electrical conductors
        or strong building materials. Selenium, another trace element, can help
        thyroid function in humans when taken in appropriate amounts. Metals and
        trace elements cover a large range of elements with a variety of
        properties.
      </p>
      <img
        style={{ height: "100%", margin: "20px auto" }}
        alt=""
        src="/static/img/storylines/metals.jpg"
      />
    </>
  );
};

export default Chapter1;
